import { useEffect, useState } from "react";
import api from "../../constants/api.js";
import { Link } from "react-router-dom";
import "./materias.css";

function Materias() {
  const [listaMaterias, setListaMaterias] = useState([]);

  useEffect(() => {
    async function fetchMaterias() {
      try {
        const response = await api.get("/materias");
        if (response.data) {
          setListaMaterias(response.data);
        }
      } catch (error) {
        console.log(error.response?.data?.error || "Erro ao buscar matérias");
      }
    }

    fetchMaterias();
  }, []);

  return (
    <div className="materias-wrapper">
      <div className="materias-lista">

        {listaMaterias.length === 0 && (
          <p>Nenhuma matéria encontrada.</p>
        )}

        {listaMaterias.map((materia) => (
          <Link
            key={materia.id_materia}
            to={`/materias/${materia.id_materia}`}
            className="materia-card"
          >
            <div className="materia-card-thumb">
              <img
                src={materia.imagem_url}
                alt={materia.titulo}
              />
            </div>

            <h2 className="materia-card-title">
              {materia.titulo}
            </h2>
          </Link>
        ))}

      </div>
    </div>
  );
}

export default Materias;
